export default {"src":"/_next/static/media/bean.5ffd8143.svg","height":84,"width":102,"blurWidth":0,"blurHeight":0};